export const gradients = {
	primary:
		'linear-gradient(135deg, rgba(0, 206, 252, 0.1) 10%, rgba(245, 133, 32, 0.05) 45%,	rgba(0, 206, 252, 0.1) 80%)',
	info: 'linear-gradient(95.78deg, rgba(75, 35, 194, 0.76) 0%, rgba(20, 82, 245, 0.56) 100%);',
};

export type ThemeGradients = typeof gradients;
